import { render, staticRenderFns } from "./KioskDetails.vue?vue&type=template&id=66f2eac0&scoped=true&"
import script from "./KioskDetails.vue?vue&type=script&lang=js&"
export * from "./KioskDetails.vue?vue&type=script&lang=js&"
import style0 from "./KioskDetails.vue?vue&type=style&index=0&id=66f2eac0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f2eac0",
  null
  
)

export default component.exports